import { gql } from "@apollo/client";

export default gql`
  mutation deleteCustomer($data: DeleteCustomerInput!){
    deleteCustomer(data: $data){
        success
        data
        code
        message
    }
}
`
